import {
  createSlice,
  isPending,
  isRejected,
  SliceSelectors,
} from "@reduxjs/toolkit";

import { submitRequestThunk, getSecureRequestLinkPageContentThunk } from "./thunks";
import { ISecureDataRequestState, SecureDataRequestReducers } from "./types";

const initialState: ISecureDataRequestState = {
  pendingRequests: 0,
  loading: false,
  error: "",
  requestData: undefined,
  submitted: false,
  processing: false,
};

export const secureDataRequestSlice = createSlice<
  ISecureDataRequestState,
  SecureDataRequestReducers,
  "secureDataRequestSlice",
  SliceSelectors<ISecureDataRequestState>
>({
  name: "secureDataRequestSlice",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setProcessing: (state, action) => {
      state.processing = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearData: state => {
      state.requestData = undefined;
      state.error = "";
      state.submitted = false;
    },
    setSubmitted: (state, action) => {
      state.submitted = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(submitRequestThunk.fulfilled, (state, { payload }) => {
      state.submitted = true;
      state.processing = false;
      state.pendingRequests -= 1;
      state.error = "";
    });
    builder.addCase(getSecureRequestLinkPageContentThunk.fulfilled, (state, { payload }) => {
      state.requestData = payload;
      state.loading = false;
      state.pendingRequests -= 1;
      state.error = "";
    });
    builder.addMatcher(
      isPending(submitRequestThunk, getSecureRequestLinkPageContentThunk),
      state => {
        state.pendingRequests += 1;
        state.error = "";
      }
    );
    builder.addMatcher(
      isRejected(submitRequestThunk, getSecureRequestLinkPageContentThunk),
      (state, action) => {
        state.pendingRequests -= 1;
        state.loading = false;
        state.processing = false;
        state.error = action.payload?.message || "Something went wrong";
      }
    );
  },
});

export const { setLoading, setProcessing, setError, clearData, setSubmitted } =
  secureDataRequestSlice.actions;
export default secureDataRequestSlice.reducer;
